<template>
  <div class="formContainer">
    <el-dialog :title="$t('system.reset_password')" :close-on-click-modal="false" :visible.sync="$store.state.user.isShowModPwdModal" width="509px" class="diglog-card" @close="initData">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('system.password_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.update_your_password_entering_new_one') }}
      </div>
      <pwd-form key="pwdForm" ref="pwdForm" @changeModalStatus="changeModalStatus" @changeStepStatus="changeStepStatus" />

      <div class="btn-container">
        <el-button type="info" class="btn-submit" @click="submitForm">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { modifyUserPwd } from '@/api/system/system'
export default {
  name: 'ModifyItem',
  components: {
    // ValiEmailForm: () => import('./ModifyLoginPwdModal/ValiEmailForm'),
    PwdForm: () => import('./ModifyLoginPwdModal/PwdForm')
  },
  data() {
    return {
      loginPwdMoalVisible: false,
      activeStep: 0,
      auth_code: ''
    }
  },
  mounted() {
    this.$bus.off('PASSWORD_AUTH_CODE')
    this.$bus.on('PASSWORD_AUTH_CODE', (value) => {
      this.auth_code = value[0]
    })
  },
  methods: {
    changeModalStatus(status) {
      this.loginPwdMoalVisible = status
    },
    changeStepStatus(num) {
      this.activeStep = num
    },
    initData() {
      this.$refs.valiEmailForm && this.$refs.valiEmailForm.initData()
      this.$refs.pwdForm && this.$refs.pwdForm.initData()
      this.changeStepStatus(0)
    },
    onClickCancel() {
      this.changeModalStatus(false)
    },
    onClickNext() {
      // 请求接口
      this.$refs.valiEmailForm.submitValiForm()
    },
    submitForm() {
      this.$refs.pwdForm.submitPwdForm()
    }
  }
}
</script>

<style scoped>

.btn-submit {
  margin-top: 32px;
  border-radius: 4px;
  width: 100%;
}

</style>
